import React from 'react';
import { useRouter } from 'next/router';
import { DocumentNode } from 'graphql';
import { ApolloProvider } from '@apollo/client';
import { ContentfulProvider } from '@cmpsr/contentful-core/lib/context/ContentfulProvider';
import { componentMap } from '@goodrx/x-matisse';
import { queryMap, ServerContext } from '@goodrx/x-core';
import { useApollo } from 'app/lib/apolloClient';

interface ContenfulWrapperProps {
  baseUrl?: string;
  initialApolloState?: DocumentNode;
  preview?: boolean;
}

export const ContentfulWrapper: React.FC<ContenfulWrapperProps> = ({
  baseUrl,
  children,
  initialApolloState,
  preview,
}) => {
  const router = useRouter();
  const apolloClient = useApollo(initialApolloState, { preview });

  return (
    <ServerContext.Provider value={{ page: { baseUrl, path: router.asPath, siteName: 'HeyDoctor' } }}>
      <ContentfulProvider componentMap={componentMap} preview={preview} queryMap={queryMap}>
        <ApolloProvider client={apolloClient}>{children}</ApolloProvider>
      </ContentfulProvider>
    </ServerContext.Provider>
  );
};
